<template>
  <nav
    :class="[
      'navbar navbar-expand-lg app-header',
      { 'is-home': isHome, 'is-scrolled': scrolled },
    ]"
  >
    <div class="container-fluid">
      <!-- 🔵 Hotelname links -->
          <router-link to="/" class="navbar-brand textcenter ps-5">
        
      </router-link>
      <router-link to="/" class="navbar-brand textcenter ps-5">
        <p class="brand-title">Home</p>
        
      </router-link>

      <!-- Mobile Toggle -->
      <button class="navbar-toggler" type="button" @click="menuOpen = !menuOpen">
        <span class="navbar-toggler-icon"></span>
      </button>

      <!--  Menü rechts -->
      <div :class="['collapse navbar-collapse', menuOpen ? 'show' : '']">
        <ul class="navbar-nav ms-auto mb-2 mb-lg-0">
          
          <li class="nav-item px-2">
            <router-link to="/kapitelfragen-quiz_A_Plus" class="nav-link">Comptia A+</router-link>
          </li>
          <li class="nav-item px-2">
            <router-link to="/kapitelfragen-quiz_N_Plus" class="nav-link">Comptia N+</router-link>
          </li>
          <li class="nav-item px-2">
            <router-link to="/kapitelfragen-quiz_S_Plus" class="nav-link">Comptia S+</router-link>
          </li>
          <li class="nav-item px-2">
            <router-link to="/sonstige-informationen" class="nav-link">Sonstiges</router-link>
          </li>
          <li class="nav-item px-2">
            <router-link to="/cybervorfall-des-tages" class="nav-link">Cybervorfall des Tages</router-link>
          </li>
          <li class="nav-item px-2">
            <router-link to="/alleFragen" class="nav-link">Übersicht der Fragen</router-link>
          </li>

        </ul>
     
      </div>
    </div>
  </nav>
</template>

<script>

export default {
  name: "AppHeader",
  data() {
    return {
      menuOpen: false,
      scrolled: false,
    };
  },
  computed: {
    isHome() {
      return this.$route.path === "/";
    },
     currentLocale() {
      return this.$i18n.locale;
    }
  },
  mounted() {
    this.onScroll();
    window.addEventListener("scroll", this.onScroll, { passive: true });
    document.addEventListener("scroll", this.onScroll, { passive: true, capture: true }); // <- wichtig
  },
  beforeUnmount() {
    window.removeEventListener("scroll", this.onScroll);
    document.removeEventListener("scroll", this.onScroll, { capture: true });
  },
  methods: {
    onScroll() {
      const y =
        window.scrollY ||
        document.documentElement.scrollTop ||
        document.body.scrollTop ||
        0;

      this.scrolled = y > 50;
    },
   toggleLanguage(lang) {
      console.log("Switching language to", lang); // Debug

      this.$i18n.locale = lang;
      localStorage.setItem("locale", lang);
    }
  },
  watch: {
    $route() {
      this.menuOpen = false;
    },
  },
};
</script>

<style scoped>
.app-header {
  position: fixed;
  top: 30px; /* Start: leicht schwebend */
  left: 0;
  right: 0;
  width: 100%;
  z-index: 9999;
  font-family: "Hind", sans-serif;

  /* 🌟 Glas-Look */
  background: rgba(255, 255, 255, 0.85); /* leicht transparent */
  backdrop-filter: blur(8px);
  -webkit-backdrop-filter: blur(8px);
  transition: top 0.25s ease, box-shadow 0.25s ease;
}

/* Beim Scrollen → ganz nach oben */
.app-header.is-scrolled {
  top: 0 !important;
  box-shadow: 0 6px 20px rgba(0, 0, 0, 0.12);
}

/* Optional: etwas Schatten auch im Anfangszustand */
.app-header:not(.is-scrolled) {
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.05);
}
.nav-item {
  justify-content: center !important;
  text-align: center;
}
navbar-brand {
  min-width: 500px;
}
.brand-title {
  font-family: Montserrat, sans-serif;
  font-style: normal;
  font-weight: 300;
  color: #000;
  font-size: 24px;
  line-height: 1.2;
  letter-spacing: 4px;
  display: block;
  margin: 0;
}
.brand-sub {
  font-family: Montserrat, sans-serif;
  font-style: normal;
  font-weight: 300;
  color: #000;
  font-size: 12px;
  line-height: 1.2;
  letter-spacing: 11px;
  display: block;
  margin: 0;
}
.nav-link {
  font-weight: 400;
  letter-spacing: 0.12em;
  text-transform: uppercase;

  font-size: 18px;
  line-height: 22px;
  font-family: Hind, sans-serif;
  font-style: normal;
  font-weight: 400;
}
</style>
